import c from '../common';

export default{

    //Column
    "Time": "時間",

    "status": c.status.chn,
    "waitForApprove": "等待審批",
    "approved": "已審批",
    "rejected": "已拒絕",

    "currency": "貨幣",

    "quantity":"劵數量",
    "amount":"金額(CAD)",

    "download": c.download.chn,

    "voucherName": c.voucher.chn + "名稱",
    "issueId": "發行ID",
};